import React, { useState } from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './successModal.scss'
import { SuccessIcon } from '../../components/Icons';
import { useNavigate } from "react-router-dom";
const SubscriptionSuccessModal = (props) => {

    const navigate = useNavigate();
    return (
        <>
            <Modal show={props.successModal} size="sm" aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header onClick={()=>navigate('/provider/profile')} closeButton></Modal.Header>
                <Modal.Body>
                    <div className='success-modal-wrapper'>
                        <div className='icon-wrap'><SuccessIcon /></div>
                        <div className='success-title'>Congratulations</div>
                        <div className='success-message'>Your have successfully subscribed.<br/>Please fill out the profile details.</div>
                        <div className='w-100 d-grid success-btn-wrapper'><Button variant='primary' onClick={()=>navigate('/provider/profile')}>Go to profile</Button></div>
                    </div>
                </Modal.Body>
            </Modal></>
    )
}

export default SubscriptionSuccessModal